import { Route, Routes, Outlet, Navigate } from 'react-router-dom';
import { PageLink, PageTitle } from '../../../_dashboard/layout/core';
import { CmsServiceListWrapper } from './cms-services-list/CmsServiceList';
import { useIntl } from 'react-intl';

const CmsServicePage = () => {
  const intl = useIntl();

  const cmsServicesBreadcrumbs: Array<PageLink> = [
    {
      title: intl.formatMessage({ id: 'CMS_SERVICE_PAGE.BREADCRUMB' }),
      path: '/apps/services-management/cms-services',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ];

  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='cms-services'
          element={
            <>
              <PageTitle breadcrumbs={cmsServicesBreadcrumbs}>
                {intl.formatMessage({ id: 'CMS_SERVICE_PAGE.TITLE' })}
              </PageTitle>
              <CmsServiceListWrapper />
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/services-management/cms-services' />} />
    </Routes>
  );
};

export default CmsServicePage;
